module.exports = __webpack_public_path__ + "public/SiteIcons/viewReceiptArrow.svg?72438718";